export default __webpack_public_path__ + "static/media/addPhotoDark.024fde74.svg";